import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SectionPage from "./SectionPage";
import Gallery from "./Gallery";
import { Reveal } from "./Reveal";
import { TRUST_BADGES } from "../data/content";
import { CATEGORY_META } from "../data/experience";

export const GalleryPage = () => (
  <SectionPage
    eyebrow="Featured Food & Events"
    title="Food That Looks Good, Travels Well, Feeds the Room"
    subtitle="Browse a curated mix of catering spreads and event setups, then dive deeper into category-specific updates and stories."
    hero="cream"
  >
    {/* Six-tile category grid bridging to the Experience pages */}
    <section data-testid="gallery-categories" className="py-12 sm:py-14 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
        <Reveal>
          <p className="text-[12px] font-bold uppercase tracking-[0.22em] text-brand-teal text-center">
            Explore by Category
          </p>
        </Reveal>
        <Reveal delay={1}>
          <h2 className="mt-2 font-display font-black text-2xl sm:text-3xl text-brand-charcoal tracking-tight text-center">
            Updates &amp; Stories
          </h2>
        </Reveal>
        <div className="mt-8 grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
          {TRUST_BADGES.map((b, i) => {
            const meta = CATEGORY_META[b.slug];
            return (
              <Reveal key={b.slug} delay={Math.min(i + 1, 6)}>
                <Link
                  to={`/experience/${b.slug}`}
                  data-testid={`gallery-category-${b.slug}`}
                  className="group relative flex flex-col h-full rounded-3xl bg-brand-cream border border-black/5 p-5 sm:p-6 transition-all hover:bg-white hover:border-brand-teal/40 hover:-translate-y-0.5 hover:shadow-[0_18px_40px_-22px_rgba(17,17,17,0.22)]"
                >
                  <span className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
                    <ArrowUpRight className="h-4 w-4 text-brand-teal" />
                  </span>
                  <p className="text-[10.5px] font-bold uppercase tracking-[0.18em] text-brand-teal">
                    {meta?.eyebrow || b.subtitle}
                  </p>
                  <h3 className="mt-2 font-display font-black text-[19px] sm:text-[22px] text-brand-charcoal tracking-tight leading-tight">
                    {b.title}
                  </h3>
                  <p className="mt-1.5 text-[12.5px] text-brand-charcoal/65 leading-snug line-clamp-2">
                    {meta?.description?.replace(/&[a-z]+;/g, "'") || b.subtitle}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-[0.14em] text-brand-charcoal/55 group-hover:text-brand-teal transition-colors">
                    View updates →
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>

    {/* The existing food photo grid */}
    <Gallery />
  </SectionPage>
);

export default GalleryPage;
